import apiHandler from "./apiHandler";

import { parseDuration, defaultPagination } from "@/utils/helpers";

const apiFlights = {
  details: (id, details = 4, showErrors = true) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/flight/${id}/${details}`, { showErrors })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  estimatePayload: (flight) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post("/flight/estimate-payload", {
          airline: flight.airline._id,
          aircraft: flight.aircraft._id,
          type: flight.type,
          depIcao: flight.dep.icao,
          arrIcao: flight.arr.icao,
          schedule: flight.schedule,
          charter: flight.charter,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  add: (flight) => {
    return new Promise((resolve, reject) => {
      // console.log(flight);
      apiHandler
        .post("/flight", {
          airline: flight.airline._id,
          aircraft: flight.aircraft._id,
          type: flight.type,
          flightNumber: flight.flightNumber,
          depIcao: flight.dep.icao,
          arrIcao: flight.arr.icao,
          depTime: flight.depTime,
          duration: parseDuration(flight.duration),
          schedule: flight.schedule,
          charter: flight.charter,
          payload: {
            pax: flight.payload.pax,
            cargo: flight.payload.cargo,
          },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deletedCount: () => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/pilot/flights/deleted`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  delete: (flight) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .delete(`/flight/${flight._id}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  preFlightCheck: (id) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post("/flight/preflight/check", {
          flight: id,
          version: window.autoUpdate.getVersion(),
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err, response) => {
          if (response !== undefined) {
            if (response.data.statusCode == 403) {
              window.autoUpdate.checkForUpdates();
            }
          }
          reject(err);
        });
    });
  },
  log: (id, message) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post("/flight/log", {
          flight: id,
          message: message,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          // console.error(err);
          // error(
          //   err.response !== undefined
          //     ? err.response.data.message
          //     : "Error occured"
          // );
          reject(
            err.response !== undefined
              ? err.response.data.message
              : "Error occured",
          );
        });
    });
  },
  setOfp: (id, ofp) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .post("/flight/ofp/" + id, {
          ofp: ofp,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getOfp: (id) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get("/flight/ofp/" + id)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  onGoing: () => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get("/flight/ongoing")
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  airline: {
    fetch: (airline, pagination, includeDeleted = false) => {
      return new Promise((resolve, reject) => {
        defaultPagination(pagination);
        apiHandler
          .post(`/airline/${airline}/flights`, {
            skip: (pagination.page - 1) * pagination.rowsPerPage,
            count: pagination.rowsPerPage,
            includeDeleted: includeDeleted,
          })
          .then((response) => {
            pagination.rowsNumber = response.data.totalResults;
            resolve({
              results: response.data.results,
              pagination,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deletedCount: (airline) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get(`/airline/${airline._id}/flights/deleted`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delete: (airline, flight) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .delete(`/airline/${airline._id}/flight/${flight._id}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    byDate: {
      fetch: (
        airline,
        pagination,
        start,
        end,
        details,
        includeDeleted,
        byClose,
      ) => {
        return new Promise((resolve, reject) => {
          // defaultPagination(pagination);
          const params = {
            start,
            end,
            details,
            includeDeleted,
            byClose,
          };

          if (pagination !== undefined) {
            params.skip = (pagination.page - 1) * pagination.rowsPerPage;
            params.count = pagination.rowsPerPage;
          }

          apiHandler
            .post(`/airline/${airline}/flights/bydate`, params)
            .then((response) => {
              if (pagination !== undefined) {
                pagination.rowsNumber = response.data.totalResults;
              }
              response.data.pagination = pagination;
              resolve(response.data);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
      airport: (
        airline,
        icao,
        pagination,
        start,
        end,
        details,
        includeDeleted,
        byClose,
      ) => {
        return new Promise((resolve, reject) => {
          // defaultPagination(pagination);
          const params = {
            start,
            end,
            details,
            includeDeleted,
            byClose,
          };
          console.log(params);

          if (pagination !== undefined) {
            params.skip = (pagination.page - 1) * pagination.rowsPerPage;
            params.count = pagination.rowsPerPage;
          }

          apiHandler
            .post(`/airline/${airline}/flights/airport/${icao}/bydate`, params)
            .then((response) => {
              if (pagination !== undefined) {
                pagination.rowsNumber = response.data.totalResults;
              }
              response.data.pagination = pagination;
              resolve(response.data);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
      aircraft: (
        airline,
        aircraft,
        pagination,
        start,
        end,
        details,
        includeDeleted,
        byClose,
      ) => {
        return new Promise((resolve, reject) => {
          // defaultPagination(pagination);
          const params = {
            start,
            end,
            details,
            includeDeleted,
            byClose,
          };

          console.log(params);

          if (pagination !== undefined) {
            params.skip = (pagination.page - 1) * pagination.rowsPerPage;
            params.count = pagination.rowsPerPage;
          }

          apiHandler
            .post(
              `/airline/${airline}/flights/aircraft/${aircraft}/bydate`,
              params,
            )
            .then((response) => {
              if (pagination !== undefined) {
                pagination.rowsNumber = response.data.totalResults;
              }
              response.data.pagination = pagination;
              resolve(response.data);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
      pilot: (
        airline,
        pilot,
        pagination,
        start,
        end,
        details,
        includeDeleted,
        byClose,
      ) => {
        return new Promise((resolve, reject) => {
          // defaultPagination(pagination);
          const params = {
            start: start,
            end: end,
            details,
            includeDeleted,
            byClose,
          };

          if (pagination !== undefined) {
            params.skip = (pagination.page - 1) * pagination.rowsPerPage;
            params.count = pagination.rowsPerPage;
          }

          apiHandler
            .post(`/airline/${airline}/flights/pilot/${pilot}/bydate`, params)
            .then((response) => {
              if (pagination !== undefined) {
                pagination.rowsNumber = response.data.totalResults;
              }
              response.data.pagination = pagination;
              resolve(response.data);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
      schedule: (
        airline,
        schedule,
        pagination,
        start,
        end,
        details,
        includeDeleted,
        byClose,
      ) => {
        return new Promise((resolve, reject) => {
          // defaultPagination(pagination);
          const params = {
            start,
            end,
            details,
            includeDeleted,
            byClose,
          };

          if (pagination !== undefined) {
            params.skip = (pagination.page - 1) * pagination.rowsPerPage;
            params.count = pagination.rowsPerPage;
          }

          apiHandler
            .post(
              `/airline/${airline}/flights/schedule/${schedule}/bydate`,
              params,
            )
            .then((response) => {
              if (pagination !== undefined) {
                pagination.rowsNumber = response.data.totalResults;
              }
              response.data.pagination = pagination;
              resolve(response.data);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
    },
  },
  airport: {
    fetchByDate: (airport, pagination, start, end, details) => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        const params = {
          start,
          end,
          details,
        };

        if (pagination !== undefined) {
          params.skip = (pagination.page - 1) * pagination.rowsPerPage;
          params.count = pagination.rowsPerPage;
        }

        apiHandler
          .post(`/airport/${airport}/flights/bydate`, params)
          .then((response) => {
            if (pagination !== undefined) {
              pagination.rowsNumber = response.data.totalResults;
            }
            response.data.pagination = pagination;
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  pilot: {
    fetchById: (id, pagination) => {
      return new Promise((resolve, reject) => {
        defaultPagination(pagination);
        apiHandler
          .post(`/pilot/flights`, {
            id,
            skip: (pagination.page - 1) * pagination.rowsPerPage,
            count: pagination.rowsPerPage,
          })
          .then((response) => {
            pagination.rowsNumber = response.data.totalResults;
            resolve({
              results: response.data.results,
              pagination,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchByDate: (pagination, start, end, includeDeleted = false) => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        const params = {
          start,
          end,
          includeDeleted: includeDeleted,
        };

        if (pagination !== undefined) {
          params.skip = (pagination.page - 1) * pagination.rowsPerPage;
          params.count = pagination.rowsPerPage;
        }

        apiHandler
          .post(`/pilot/flights/bydate`, params)
          .then((response) => {
            if (pagination !== undefined) {
              pagination.rowsNumber = response.data.totalResults;
            }
            response.data.pagination = pagination;
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deletedCount: () => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get(`/pilot/flights/deleted`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    next: () => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get("/pilot/nextflight")
          .then((response) => {
            resolve({
              results: response.data,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    last: () => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get("/pilot/lastflight")
          .then((response) => {
            resolve({
              results: response.data,
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default apiFlights;
